import { v4 as uuid } from 'uuid';
import {
  Log,
  LogLevel,
} from '@wix/ambassador-genie-chat-service-v1-no-entity/types';
import { ChatWidgetLog, ChatWidgetLogLevel } from '../../domain/logs';

export const convertPlatformLogs = (logs?: Log[]): ChatWidgetLog[] =>
  (logs ?? []).map((log) => ({
    id: uuid(),
    agentName: log.agentName ?? null,
    level: convertPlatformLogLevel(log.level),
    timestamp: log.timestamp ?? new Date(0),
    platformLog: {
      message: log.message ?? null,
      jsonData: log.jsonData ?? null,
    },
  }));

export const convertPlatformLogLevel = (
  platformLogLevel?: LogLevel,
): ChatWidgetLogLevel => {
  switch (platformLogLevel) {
    case LogLevel.INFO:
      return ChatWidgetLogLevel.Info;
    case LogLevel.WARN:
      return ChatWidgetLogLevel.Warning;
    case LogLevel.ERROR:
      return ChatWidgetLogLevel.Error;
    default:
      console.error(
        `Unknown platform log level: ${platformLogLevel}. Fallback to "info"`,
      );
      return ChatWidgetLogLevel.Info;
  }
};
